import React from 'react'
import axios from 'axios'

import Button from '../Form/Button'

const ANEXO_COD_REGEX = /(^|[^A-Fa-f0-9])([A-Fa-f0-9]{20})(?=$|[^A-Fa-f0-9])/g
const PAF_NUMERO_REGEX = /(\b\d{1,6}\/\d{4}-[A-Za-z]{2,10}-[A-Za-z]{2}\b)/g

export default class Resposta extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: { resposta: '', dataResposta: new Date().toLocaleDateString() },
            anexoCodCarregando: null,
            pafNumeroCarregando: null
        }
    }

    componentDidMount() {
        const id = this.props.match.params.id
        const url = `/api/suporte/getChamado/${id}`
        axios(url)
            .then(resp => {
                const ficha = { ...resp.data, dataResposta: new Date().toLocaleDateString() }
                this.setState({ ficha })
            })
            .catch(error => {
                const mensagemErro = error && error.response && error.response.data ? error.response.data : (error.message || error)
                alert(mensagemErro)
            }
            )
    }

    updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
    }

    save(e) {
        e.preventDefault()
        const url = '/api/suporte/resposta'
        const ficha = this.state.ficha
        axios.post(url, ficha)
            .then(res => {
                alert('Resposta enviada.')
                window.location = `/suporte`
            })
            .catch(error => {
                const mensagemErro = error && error.response && error.response.data ? error.response.data : (error.message || error)
                alert(mensagemErro)
            })
    }

    abrirAnexoReferenciado = (codOriginal) => {
        const cod = String(codOriginal || '').trim().toLowerCase()

        if (!cod || this.state.anexoCodCarregando === cod) {
            return
        }

        this.setState({ anexoCodCarregando: cod })

        // Procura o cod em qualquer tipo de documento (anexo, despacho, certidão,
        // A.I/TV) de um PAF ou de um Processo antigo (PAD).
        axios.post('/api/paf/findDocByCod', { cod })
            .then(resp => {
                const doc = resp && resp.data ? resp.data : null

                if (!doc || !doc._id) {
                    throw new Error('Não foi possível localizar o documento informado.')
                }

                const rota = doc.origem === 'processo' ? 'documentos' : 'documentosPaf'
                window.location = `/${rota}/${doc._id}?highlightCod=${encodeURIComponent(cod)}`
            })
            .catch(error => {
                const mensagemErro = error && error.response && error.response.data ? error.response.data : (error.message || 'Não foi possível localizar o documento informado.')
                alert(mensagemErro)
                this.setState({ anexoCodCarregando: null })
            })
    }

    abrirPafReferenciado = (numeroOriginal) => {
        const numero = String(numeroOriginal || '').trim()

        if (!numero || this.state.pafNumeroCarregando === numero) {
            return
        }

        this.setState({ pafNumeroCarregando: numero })

        axios.post('/api/paf/findPafByNumero', { numero })
            .then(resp => {
                const paf = resp && resp.data ? resp.data : null

                if (!paf || !paf._id) {
                    throw new Error('Não foi possível localizar o PAF informado.')
                }

                window.location = `/documentosPaf/${paf._id}`
            })
            .catch(error => {
                const mensagemErro = error && error.response && error.response.data ? error.response.data : (error.message || 'Não foi possível localizar o PAF informado.')
                alert(mensagemErro)
                this.setState({ pafNumeroCarregando: null })
            })
    }

    getMensagemComLinksParts = (mensagem = '') => {
        const texto = String(mensagem || '')
        const partes = []
        const regex = new RegExp(`${ANEXO_COD_REGEX.source}|${PAF_NUMERO_REGEX.source}`, 'g')
        let ultimoIndice = 0
        let match

        while ((match = regex.exec(texto)) !== null) {
            const valorCompleto = match[0]
            const inicio = match.index

            if (inicio > ultimoIndice) {
                partes.push({ tipo: 'texto', valor: texto.slice(ultimoIndice, inicio) })
            }

            if (match[2]) {
                const delimitador = match[1] || ''

                if (delimitador) {
                    partes.push({ tipo: 'texto', valor: delimitador })
                }

                partes.push({ tipo: 'cod', valor: match[2], chave: `${match[2]}-${inicio + delimitador.length}` })
                ultimoIndice = inicio + valorCompleto.length
                continue
            }

            partes.push({ tipo: 'paf', valor: valorCompleto, chave: `${valorCompleto}-${inicio}` })
            ultimoIndice = inicio + valorCompleto.length
        }

        if (ultimoIndice < texto.length) {
            partes.push({ tipo: 'texto', valor: texto.slice(ultimoIndice) })
        }

        return partes.length > 0 ? partes : [{ tipo: 'texto', valor: texto }]
    }

    renderMensagemComLinks() {
        const partes = this.getMensagemComLinksParts(this.state.ficha.mensagem)
        const { anexoCodCarregando, pafNumeroCarregando } = this.state

        return partes.map((parte, index) => {
            if (parte.tipo === 'texto') {
                return <React.Fragment key={`texto-${index}`}>{parte.valor}</React.Fragment>
            }

            if (parte.tipo === 'cod') {
                const codNormalizado = String(parte.valor || '').trim().toLowerCase()
                const carregando = anexoCodCarregando === codNormalizado

                return (
                    <button
                        type="button"
                        key={parte.chave || `cod-${index}`}
                        disabled={carregando}
                        onClick={() => this.abrirAnexoReferenciado(parte.valor)}
                        style={{
                            border: 'none',
                            background: 'transparent',
                            padding: 0,
                            margin: 0,
                            color: carregando ? '#6c757d' : '#0056b3',
                            textDecoration: 'underline',
                            cursor: carregando ? 'progress' : 'pointer',
                            fontWeight: 600
                        }}
                        title={carregando ? 'Localizando documento...' : 'Abrir documento referenciado'}>
                        {parte.valor}
                    </button>
                )
            }

            const carregando = pafNumeroCarregando === parte.valor

            return (
                <button
                    type="button"
                    key={parte.chave || `paf-${index}`}
                    disabled={carregando}
                    onClick={() => this.abrirPafReferenciado(parte.valor)}
                    style={{
                        border: 'none',
                        background: 'transparent',
                        padding: 0,
                        margin: 0,
                        color: carregando ? '#6c757d' : '#0056b3',
                        textDecoration: 'underline',
                        cursor: carregando ? 'progress' : 'pointer',
                        fontWeight: 600
                    }}
                    title={carregando ? 'Localizando PAF...' : 'Abrir documentos do PAF'}>
                    {parte.valor}
                </button>
            )
        })
    }

    render() {
        return (
            <div className="container mx-auto">
                <div className="form-group row pt-3 text-left">
                    <label className="col-3 col-md-2">Usuário:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control" value={this.state.ficha.user || ''} readOnly />
                    </div>
                    <label className="col-3 col-md-2">Tipo:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control" value={this.state.ficha.tipo || ''} readOnly />
                    </div>
                    <label className="col-12">Texto:</label>
                    <div className="form-control textarea text-left" style={{ whiteSpace: 'pre-wrap' }}>{this.renderMensagemComLinks()}</div>
                </div>
                <br /><hr /><br />
                <div className="form-group row mt-3 text-left">
                    <label className="col-12">Resposta:</label>
                    <textarea type="textarea" rows="8" className="form-control col-12 mb-5"
                        name="resposta" onChange={e => this.updateField(e)} />
                </div>
                <Button onClick={e => this.save(e)} />
            </div>
        )
    }
}
